import React from "react";
import Modal from '../Modal'
import LoaderButton from "../../components/LoaderButton";
import { checkTranslation, translate } from "../../utils/useful";
import LabelPrinter from "../inputs/LabelPrinter";
import { labelSizeTemplates, paperSizeTemplates } from "../../variables/framesStatics";


class PrintFinalModal extends React.Component {
    state = {
        headers: [
            { key: 'papersize', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: '{{lang}}Less Than', value: 'Equal' }], label: '{{lang}}Paper Size', placeholder: 'A4 (210mm x 297mm)', required: true } },
            { key: 'layout', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: '{{lang}}Less Than', value: 'Equal' }], label: '{{lang}}Layout', placeholder: '{{lang}}Landscape', required: true } },
            { key: 'fieldsizing', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: '{{lang}}Less Than', value: 'Equal' }], label: '{{lang}}Feild sizing', placeholder: '{{lang}}Actual size', required: true } },
            { key: 'fontsize', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: '{{lang}}Less Than', value: 'Equal' }], label: '{{lang}}Font size', placeholder: '{{lang}}Normal', required: true } },
        ],

        options: [
            { title: "{{lang}}Add view name as title" },
            { title: "{{lang}}Include row Numbers" },
            { title: "{{lang}}Wrap long text into multiple lines" },
        ]
    }
    getScaleAndHeight = (paperSize,labelSize) => {
        if (paperSize) {

            const maxWidth = 500;
            const width = paperSizeTemplates[paperSize]?.width * 3.78 || 1;
            const height = paperSizeTemplates[paperSize]?.height * 3.78 || 1;

            // // Calculate scale to fit within 350px width
            const scale = maxWidth / width 
            // const scale = (maxWidth* labelSizeTemplates[labelSize]?.width) / (paperSizeTemplates[paperSize]?.width * 300) //300 is width in templates

            // Calculate scaled height
            const scaledHeight = height * scale ;

            return { scale, scaledHeight };
        } else {
            const scale = 500

            const scaledHeight = '100%'

            return { scale, scaledHeight };
        }
    };

    render() {
        if (this.props.data && this.props.data?.paperSize) {
            const { scale, scaledHeight } = this.getScaleAndHeight(this.props.data?.paperSize,this.props.data?.labelSize);
            const sizes = labelSizeTemplates
            let options = this.state.options
            return (

                <Modal maxWidth={500} height={scaledHeight} ref={el => this.modal = el}>
                    <div className="w-100 br-10" style={{ backgroundColor: "white", overflow: 'hidden' }} >
                        <LabelPrinter scaledHeight={scaledHeight} scale={scale} width={this.props.width} colors={this.props.colors} data={this.props.data} labels={this.props.data?.labels} isLoading={this.state.isLoadingData} changeValue={this.changeValue} setHeader={this.props.setHeader} />

                    </div>
                </Modal>
            );

        } else {
            return (

                <></>
            );
        }
    }
}


export default PrintFinalModal;
